import { DangerAlert, SuccessAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import EmailQuoteModal from "components/common/EmailQuoteModal";
import MergeCustomerModal from "components/common/MergeCustomerModal";
import ModalX from "components/common/Modal";
import { QuoteStatus } from "enums/QuoteStatus";
import { UnitPriceType } from "enums/UnitPriceType";
import Quote from "interfaces/Quote";
import * as moment from "moment";
import * as numeral from "numeral";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import apifetch from "utils/apifetch";
import downloadBlob from "utils/downloadBlob";
import downloadResponse from "utils/downloadResponse";
import extractErrorMessage from "utils/extractErrorMessage";
import SaleOrderAlert from "./SaleOrderAlert";
import "./View.css";

interface RouteParams {
    id: number;
}

interface State {
    isLoading: boolean;
    historySection: number;
    isEditingQuoteStatus: boolean;
    data: Quote;
    tabs: string[];
    previewId: null | number;
    bottomTabsOffsetTop: number;
    emailStatus?: {
        type: "success" | "error";
        message: string;
    };
}

interface Email {
    customerId?: number;
    sender: string;
    recipient: string;
    cc: string;
    bcc: string;
    subject: string;
    message: string;
}

export default class View extends React.Component<
    RouteComponentProps<RouteParams>,
    State
> {
    private readonly baseUrl: string;
    private mergeCustomerModalRef: React.RefObject<MergeCustomerModal>;
    private emailQuoteModalRef: React.RefObject<EmailQuoteModal>;
    private bottomTabs: any;

    constructor(props: RouteComponentProps<RouteParams>) {
        super(props);

        this.state = {
            isLoading: true,
            historySection: 0,
            isEditingQuoteStatus: false,
            data: {} as any, // Will be assigned to when componentDidMount is called.
            tabs: [],
            previewId: null,
            bottomTabsOffsetTop: 0,
            emailStatus: undefined,
        };
        this.bottomTabs = React.createRef();
        this.baseUrl = document
            .getElementsByTagName("base")[0]
            .getAttribute("href")!;
        this.mergeCustomerModalRef = React.createRef();
        this.emailQuoteModalRef = React.createRef();

        this.viewPdf = this.viewPdf.bind(this);
        this.viewPdfForCustomer = this.viewPdfForCustomer.bind(this);
        this.handleSubmitFormoveCustomerToExistingQuote =
            this.handleSubmitFormoveCustomerToExistingQuote.bind(this);
        this.openEmailModal = this.openEmailModal.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleViewGrossMargin = this.handleViewGrossMargin.bind(this);
        this.handleStartEditQuoteStatus =
            this.handleStartEditQuoteStatus.bind(this);
        this.handleQuoteStatusChanged = this.handleQuoteStatusChanged.bind(this);
        this.scrollToSalesOrderHistory = this.scrollToSalesOrderHistory.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        let quoteId = this.state.data.id.toString();
        if (this.state.data.isMaster) {
            quoteId += "M";
        }
        if (this.state.data.revisionDate) {
            quoteId += ", rev " + moment(this.state.data.revisionDate).format("l");
        }
        if (this.state.data.isDraft) {
            quoteId += " (Draft)";
        }

        return (
            <div className="container">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/quotes">Quotes</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>
                            {this.state.data.jobName}
                        </BreadcrumbLink>
                    </Breadcrumb>

                    {this.state.emailStatus &&
                        (this.state.emailStatus.type === "success" ? (
                            <SuccessAlert name="emailStatusAlert">
                                {this.state.emailStatus.message}
                            </SuccessAlert>
                        ) : (
                            <DangerAlert name="emailStatusAlert">
                                {this.state.emailStatus.message}
                            </DangerAlert>
                        ))}

                    <SaleOrderAlert />
                    <div className="button-actions button-actions--custom">
                        <div className="button-actions__col">
                            <Link
                                to={"/quotes/edit/" + this.state.data.id}
                                className="btn btn-primary large"
                            >
                                {" "}
                                <i className="icon-edit1"></i>Edit this Quote
                            </Link>

                            {!this.state.data.isMaster &&
                                this.state.data.canCreateSalesOrder && (
                                    <Link
                                        to={"/quotes/salesorder/" + this.state.data.id}
                                        className="btn btn-primary"
                                    >
                                        {" "}
                                        <i className="icon icon-circle-add"></i>Create Sales Order
                                    </Link>
                                )}
                            {!this.state.data.isMaster &&
                                this.state.data.canCreateSalesOrder && (
                                    <button
                                        className="btn btn-primary"
                                        onClick={this.scrollToSalesOrderHistory}
                                    >
                                        View Sales Orders
                                    </button>
                                )}
                        </div>
                        <div
                            className="button-actions__col button-actions--desktop "
                            style={{ marginTop: "10px" }}
                        >
                            {this.state.data.customers.length === 1 && (
                                <a
                                    href="#"
                                    className="btn btn--secondary"
                                    onClick={this.openEmailModal}
                                >
                                    <i className="icon-paper-plane"></i>Send Email
                                </a>
                            )}
                            <a
                                href="#"
                                onClick={this.viewPdf}
                                target="_blank"
                                className="btn btn--secondary"
                            >
                                {" "}
                                <i className="icon-pdf"></i>Download
                            </a>
                        </div>
                    </div>
                    <div className="box-wrap">
                        <h2 className="card__title">Overview</h2>
                        <div className="box">
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label field-label-view">Project Name</span>
                                    <span className="field-item">{this.state.data.jobName}</span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label ">City</span>
                                    <span className="field-item">{this.state.data.jobCity}</span>
                                </div>
                            </div>
                            {this.state.data.parentQuoteId && <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label field-label-view">Master Quote ID</span>
                                    <span className="field-item">{this.state.data.parentQuoteId}</span>
                                </div>
                            </div>
                            }
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label field-label-view">Quote ID</span>
                                    <span className="field-item">{quoteId}</span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">PO #</span>
                                    <span className="field-item">
                                        {this.state.data.purchaseOrderNumber}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label field-label-view">Date</span>
                                    <span className="field-item">
                                        {this.state.data.date &&
                                            moment(this.state.data.date).format("LL")}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Expiry Date</span>
                                    <span className="field-item">
                                        {this.state.data.expirationDate &&
                                            moment(this.state.data.expirationDate).format("LL")}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label field-label-view">Bid Date</span>
                                    <span className="field-item">
                                        {this.state.data.jobBidDate &&
                                            moment(this.state.data.jobBidDate).format("LL")}
                                    </span>
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Salesperson</span>
                                    <span className="field-item">
                                        {this.state.data.salespersonName}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="field-group col-sm-6 quote-status">
                                    <span className="field-label field-label-view">Status</span>
                                    {this.state.isEditingQuoteStatus ? (
                                        <select
                                            className="form-control selectbox"
                                            style={{ paddingTop: "0", paddingBottom: "0" }}
                                            onChange={this.handleQuoteStatusChanged}
                                            value={this.state.data.quoteStatusId}
                                        >
                                            <option value={QuoteStatus.Pending}>Pending</option>
                                            <option value={QuoteStatus.LowAppBidder}>
                                                Low Apparent Bidder
                                            </option>
                                            <option value={QuoteStatus.ReQuotePending}>
                                                Re-Quote Pending
                                            </option>
                                            {BQS && (
                                                <option value={QuoteStatus.BrentAward}>
                                                    Brent Award
                                                </option>
                                            )}
                                            {BQS && (
                                                <option value={QuoteStatus.BrentPartialAward}>
                                                    Brent Partial Award
                                                </option>
                                            )}
                                            {BQS && (
                                                <option value={QuoteStatus.BrentLostJob}>
                                                    Brent Lost Project
                                                </option>
                                            )}
                                            {CQS && (
                                                <option value={QuoteStatus.BrentAward}>
                                                    Caterina Award
                                                </option>
                                            )}
                                            {CQS && (
                                                <option value={QuoteStatus.BrentPartialAward}>
                                                    Caterina Partial Award
                                                </option>
                                            )}
                                            {CQS && (
                                                <option value={QuoteStatus.BrentLostJob}>
                                                    Caterina Lost Project
                                                </option>
                                            )}
                                            <option value={QuoteStatus.CustomerDidNotGetJob}>
                                                Customer Did Not Get Project
                                            </option>
                                            <option value={QuoteStatus.Cancelled}>Cancelled</option>
                                            <option value={QuoteStatus.Void}>Void</option>
                                            <option value={QuoteStatus.Closed}>Closed</option>
                                        </select>
                                    ) : (
                                        <span className="field-item">
                                            {this.state.data.quoteStatusName}{" "}
                                            <a
                                                href="#"
                                                className="btn-edit ml-2"
                                                onClick={this.handleStartEditQuoteStatus}
                                            >
                                                <i className="icon-edit1"></i>
                                            </a>
                                        </span>
                                    )}
                                </div>
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Taxable</span>
                                    <span className="field-item">{this.state.data.salesTaxRate != null ? "Yes" : "No"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card card--datatables pb-4 mb-0">
                        <div className="card-block">
                            <h2 className="card__title">Customers</h2>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Customer</th>
                                        <th>ATTN</th>
                                        <th style={{ width: "1%" }}></th>
                                        <th style={{ width: "1%" }}></th>
                                        <th style={{ width: "1%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.customers.map((item, index) => (
                                        <tr key={item.customerId}>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <Link to={"/customers/" + item.customerId}>
                                                    {item.customerName} ({item.customerApiType === 1 ? "BC" : SITE_NAME})
                                                </Link>
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                {item.customerContactName}
                                            </td>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <div className="status-dropdown">
                                                    <a
                                                        data-toggle="dropdown"
                                                        href="#"
                                                        role="button"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        Actions<i className="icon-cheveron-down-black"></i>
                                                    </a>
                                                    <div className="dropdown-menu dropdown-menu-left">
                                                        {this.state.data.isMaster && <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={(event) =>
                                                                this.moveCustomerToNewQuote(
                                                                    event,
                                                                    item.customerId
                                                                )
                                                            }
                                                        >
                                                            Move to new quote
                                                        </a>
                                                        }
                                                        {this.state.data.isMaster && <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={(event) =>
                                                                this.moveCustomerToNewQuoteAsLowBidder(
                                                                    event,
                                                                    item.customerId
                                                                )
                                                            }
                                                        >
                                                            Move to new quote as low bidder
                                                        </a>
                                                        }
                                                        <a
                                                            className="dropdown-item"
                                                            href="#"
                                                            onClick={(event) =>
                                                                this.moveCustomerToExistingQuote(
                                                                    event,
                                                                    item.customerId
                                                                )
                                                            }
                                                        >
                                                            {" "}
                                                            Move to existing quote
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <a
                                                    href="#"
                                                    onClick={(event) => this.openEmailModal(event, index)}
                                                    className="btn btn-primary"
                                                    style={{ display: "inline-block" }}
                                                >
                                                    Email
                                                </a>
                                            </td>
                                            <td>
                                                <a
                                                    href="#"
                                                    onClick={(event) =>
                                                        this.viewPdfForCustomer(event, item.customerId)
                                                    }
                                                    className="btn btn-primary"
                                                    style={{ display: "inline-block" }}
                                                >
                                                    View PDF
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/*<div className="button-actions text-center">*/}
                    {/*    <a href="#" onClick={this.handleViewGrossMargin} target="_blank" className="btn">Gross Margin</a>*/}
                    {/*</div>*/}
                    <div className="button-actions  mb-4 pb-4">
                        <a
                            href="#"
                            onClick={this.handleViewGrossMargin}
                            target="_blank"
                            className="btn btn--secondary mlr-0"
                        >
                            <i className="icon-download"></i>
                            Download Gross Margin
                        </a>
                    </div>
                    <div className="card card--datatables pb-4 mb-0">
                        <div className="card-block">
                            <h2 className="card__title">Material Details</h2>
                            {this.state.data.productGroups.map((item, index) => (
                                <div key={item.name}>
                                    <h5>{item.name}</h5>
                                    <table className="table mb-4">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "10%" }}>Quantity</th>
                                                <th style={{ width: "10%" }}>UM</th>
                                                <th style={{ width: "30%" }}>Item</th>
                                                <th style={{ width: "30%" }}>Notes</th>
                                                <th style={{ width: "10%" }}>Price</th>
                                                <th style={{ width: "10%" }}>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.products.map((item, index) => (
                                                <tr key={item.productId}>
                                                    <td>
                                                        {item.unitPriceTypeId !== UnitPriceType.Note &&
                                                            item.quantity}
                                                    </td>
                                                    <td>{item.unitMeasurement}</td>
                                                    <td>
                                                        {!item.productId &&
                                                            item.notes &&
                                                            item.unitPriceTypeId !== UnitPriceType.Note
                                                            ? item.notes
                                                            : item.productName}
                                                    </td>
                                                    <td>
                                                        {(item.productId ||
                                                            item.unitPriceTypeId === UnitPriceType.Note) &&
                                                            item.notes}
                                                    </td>
                                                    <td className="text-right">
                                                        {item.unitPriceTypeId
                                                            ? item.unitPriceTypeName
                                                            : numeral(item.price).format("$0,0.00")}
                                                    </td>
                                                    <td className="text-right">
                                                        {!item.unitPriceTypeId &&
                                                            numeral(item.amount).format("$0,0.00")}
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr className="sub-total">
                                                <td colSpan={4}></td>
                                                <td>Subtotal</td>
                                                <td className="text-right">
                                                    {numeral(item.subTotal).format("$0,0.00")}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="grand-total-box">
                        {this.state.data.salesTaxRate !== null && (
                            <div className="sales-tax2">
                                <span>
                                    Sales Tax (
                                    {numeral(this.state.data.salesTaxRate!).format("0.[0000]%")})
                                </span>
                                <span>
                                    {numeral(this.state.data.salesTax!).format("$0,0.00")}
                                </span>
                            </div>
                        )}
                        <div className="grand-total2">
                            <span>Grand Total</span>
                            <span>{numeral(this.state.data.price).format("$0,0.00")}</span>
                        </div>
                    </div>

                    {/* Create New sales order section */}
                    <div className=" text-right" style={{ margin: "20px" }}>
                        {!this.state.data.isMaster &&
                            this.state.data.canCreateSalesOrder && (
                                <Link
                                    to={"/quotes/salesorder/" + this.state.data.id}
                                    className="btn btn-primary"
                                >
                                    {" "}
                                    <i className="icon icon-circle-add"></i>Create Sales Order
                                </Link>
                            )}
                    </div>
                    {/* Create New sales order section End */}

                    {/* Action Button */}
                    <div className="button-actions text-center">
                        {this.state.data.customers.length === 1 && (
                            <a href="#" className="btn" onClick={this.openEmailModal}>
                                Email Quote
                            </a>
                        )}
                        <Link to={"/quotes/edit/" + this.state.data.id} className="btn">
                            Edit Quote
                        </Link>
                        <a href="#" onClick={this.viewPdf} target="_blank" className="btn">
                            View PDF
                        </a>
                    </div>
                    {/* Action Button End */}

                    {/* History section */}
                    <section id="history" ref={this.bottomTabs}>
                        <div className="card card--datatables pb-4 mb-0">
                            <div className="card-block">
                                <h2 className="card__title">History</h2>
                                <div id="horizontalTab" className="r-tabs">
                                    <ul className="r-tabs-nav">
                                        {this.state.tabs.map((item, index) => (
                                            <li
                                                className={`r-tabs-tab ${this.state.historySection === index
                                                    ? "r-tabs-state-active"
                                                    : ""
                                                    }`}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => this.setState({ historySection: index })}
                                                key={index}
                                            >
                                                <div className="r-tabs-anchor">{item}</div>
                                            </li>
                                        ))}
                                    </ul>

                                    <div>
                                        <div className="table-responsive">
                                            {this.state.historySection === 0 && (
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.data.quoteHistories.map(
                                                            (item: any, index: number) => (
                                                                <tr key={item.id}>
                                                                    <td>
                                                                        <Link to={"/quotes/history/" + item.id}>
                                                                            {moment(item.revisionDate).format("LLL")}
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            )}

                                            {this.state.historySection === 1 && (
                                                <table className="table">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: "150px" }}>Date</th>
                                                            <th>Sales Order ID (Shipping Method)</th>

                                                            <th>Purchase Order ID (Vendor Name)</th>
                                                            <th>Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.data.quoteOrders.map((item, index) => (
                                                            <tr key={item.id}>
                                                                <td>{moment(item.date).format("LLL")}</td>
                                                                <td>
                                                                    {(() => {
                                                                        const isExternalLink = item.salesOrderUrl?.startsWith("http");
                                                                        const salesOrderLabel = `${item.salesOrderNumber} (${item.shippingMethod == "1"
                                                                            ? "Direct"
                                                                            : item.shippingMethodYard == "1"
                                                                                ? "Yard Pickup"
                                                                                : "Yard Delivery"
                                                                            })`;

                                                                        const handlePreview = () => {
                                                                            this.setState({ previewId: index });
                                                                        };

                                                                        const isPreviewOpen = index === this.state.previewId;

                                                                        return (
                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {item.salesOrderUrl ? (
                                                                                    isExternalLink ? (
                                                                                        <a
                                                                                            href={item.salesOrderUrl}
                                                                                            target="_blank"
                                                                                            rel="noopener noreferrer"
                                                                                        >
                                                                                            {salesOrderLabel}
                                                                                        </a>
                                                                                    ) : (
                                                                                        <Link to={item.salesOrderUrl}>{salesOrderLabel}</Link>
                                                                                    )
                                                                                ) : (
                                                                                    <>Pending</>
                                                                                )}

                                                                                <svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    width="1.2em"
                                                                                    height="1.2em"
                                                                                    style={{ marginLeft: "40px", cursor: "pointer" }}
                                                                                    viewBox="0 0 512 512"
                                                                                    onClick={handlePreview}
                                                                                >
                                                                                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                                                                                </svg>

                                                                                {isPreviewOpen && (
                                                                                    <ModalX
                                                                                        data={item}
                                                                                        open={this.state.previewId !== null}
                                                                                        onClose={() => this.setState({ previewId: null })}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </td>

                                                                <td>
                                                                    {(() => {
                                                                        if (!item.purchaseOrderNumber) return null;

                                                                        const isExternalLink = item.purchaseOrderUrl?.startsWith("http");
                                                                        const purchaseOrderLabel = `${item.purchaseOrderNumber} (${item.selectedVendorName})`;
                                                                        const url = item.purchaseOrderUrl || "/";

                                                                        return (
                                                                            <div>
                                                                                {isExternalLink ? (
                                                                                    <a
                                                                                        href={url}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        {purchaseOrderLabel}
                                                                                    </a>
                                                                                ) : (
                                                                                    <Link to={url}>{purchaseOrderLabel}</Link>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })()}
                                                                </td>

                                                                <td>
                                                                    {(() => {
                                                                        if (item.isDraft) {
                                                                            return (
                                                                                <Link
                                                                                    to={`/quotes/salesorder/${this.props.match.params.id}/${item.id}`}
                                                                                >
                                                                                    <span className="badge bg-warning">
                                                                                        Draft
                                                                                    </span>
                                                                                </Link>
                                                                            );
                                                                        } else {
                                                                            if (item.salesOrderUrl)
                                                                                return (
                                                                                    <Link
                                                                                        to={item.salesOrderUrl}
                                                                                        target="_blank"
                                                                                    >
                                                                                        <span className="badge bg-success">
                                                                                            Active
                                                                                        </span>
                                                                                    </Link>
                                                                                );
                                                                            else
                                                                                return (
                                                                                    <Link to="#">
                                                                                        <span className="badge bg-success">
                                                                                            Active
                                                                                        </span>
                                                                                    </Link>
                                                                                );
                                                                        }
                                                                    })()}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* History section End */}
                </div>
                <MergeCustomerModal
                    ref={this.mergeCustomerModalRef}
                    onClose={this.handleSubmitFormoveCustomerToExistingQuote}
                />
                <EmailQuoteModal
                    ref={this.emailQuoteModalRef}
                    onSubmit={this.sendEmail}
                />
            </div>
        );
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch(
                "quotes/" + this.props.match.params.id,
                undefined,
                true
            );
            if (response.ok) {
                let data = (await response.json()) as Quote;
                let tabs =
                    !data.isMaster && data.canCreateSalesOrder
                        ? ["Changes History", "Sales Order History"]
                        : ["Changes History"];
                this.setState({
                    isLoading: false,
                    data: data,
                    tabs: tabs,
                });

                document.title = `Viewing Quote for ${this.state.data.jobName} - Quotes - ${SITE_NAME}`;

                !data.isMaster &&
                    data.canCreateSalesOrder &&
                    this.setState({ historySection: 1 });
            }
            const scrollData = this.props.location.state?.data;
            if (scrollData && scrollData.scrollToBottom) {
                this.scrollToSalesOrderHistory();
            }
        }
    }


    private async viewPdf(event: React.SyntheticEvent<HTMLAnchorElement>) {
        event.preventDefault();

        let response = await apifetch(
            "quotes/pdf/" + this.props.match.params.id,
            undefined,
            true
        );
        let blob = await response.blob();

        downloadBlob(blob, `Quote ${this.props.match.params.id}.pdf`, {
            type: "application/pdf",
        });
    }

    private async viewPdfForCustomer(
        event: React.SyntheticEvent<HTMLAnchorElement>,
        customerId: number
    ) {
        event.preventDefault();

        let response = await apifetch(
            `quotes/pdf/${this.props.match.params.id}/customer/${customerId}`,
            undefined,
            true
        );
        let blob = await response.blob();

        downloadBlob(blob, `Quote ${this.props.match.params.id}.pdf`, {
            type: "application/pdf",
        });
    }

    private async moveCustomerToNewQuote(
        event: React.SyntheticEvent<HTMLAnchorElement>,
        customerId: number
    ) {
        event.preventDefault();

        let data = {
            customerId: customerId,
        };
        let response = await apifetch(
            `quotes/split/${this.props.match.params.id}`,
            {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                method: "POST",
                body: JSON.stringify(data),
            },
            true
        );
        if (response.ok) {
            let responseData = await response.json();
            this.props.history.push("/quotes"); // Hacky way of forcing the page to reload
            this.props.history.push("/quotes/" + responseData.id);
        }
    }

    private async moveCustomerToNewQuoteAsLowBidder(
        event: React.SyntheticEvent<HTMLAnchorElement>,
        customerId: number
    ) {
        event.preventDefault();

        let data = {
            customerId: customerId,
            quoteStatusId: QuoteStatus.LowAppBidder,
        };
        let response = await apifetch(
            `quotes/split/${this.props.match.params.id}`,
            {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                method: "POST",
                body: JSON.stringify(data),
            },
            true
        );
        if (response.ok) {
            let responseData = await response.json();
            this.props.history.push("/quotes"); // Hacky way of forcing the page to reload
            this.props.history.push("/quotes/" + responseData.id);
        } else {
            let errorMessage = "Failed to move customer to new quote as low bidder.";
            try {
                const errorData = await response.text();
                if (errorData) {
                    errorMessage = errorData;
                }
            } catch (e) {
                // Ignore parse errors
            }
            alert(errorMessage);
        }
    }

    private moveCustomerToExistingQuote(
        event: React.SyntheticEvent<HTMLAnchorElement>,
        customerId: number
    ) {
        event.preventDefault();

        this.mergeCustomerModalRef.current!.setState({
            isModalOpen: true,
            customerId: customerId,
        });
    }

    private async handleSubmitFormoveCustomerToExistingQuote(data: {
        quoteId: number;
        customerId: number;
    }) {
        if (data.quoteId === 0 || data.customerId === 0) {
            return;
        }

        let newData = {
            oldQuoteId: this.props.match.params.id,
            newQuoteId: data.quoteId,
            customerId: data.customerId,
        };

        let response = await apifetch(
            "quotes/merge",
            {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                method: "POST",
                body: JSON.stringify(newData),
            },
            true
        );
        if (response.ok) {
            let responseData = await response.json();
            this.props.history.push("/quotes"); // Hacky way of forcing the page to reload
            this.props.history.push("/quotes/" + responseData.id);
        }
    }

    private async openEmailModal(
        event: React.SyntheticEvent<HTMLAnchorElement>,
        customerIndex?: number
    ) {
        event.preventDefault();

        let customerId;
        let customerName = "";

        if (customerIndex !== undefined) {
            customerId = this.state.data.customers[customerIndex].customerId;
            customerName = this.state.data.customers[customerIndex].customerName;
        } else {
            if (this.state.data.customers.length === 1) {
                customerId = this.state.data.customers[0].customerId;
                customerName = this.state.data.customers[0].customerName;
            } else {
                customerName = "All Customers on Quote";
            }
        }

        let response = await apifetch(
            `quotes/email/${this.props.match.params.id}`,
            undefined,
            true
        );
        if (response.ok) {
            let data = await response.json();
            this.emailQuoteModalRef.current!.setState({
                isModalOpen: true,
                customerId: customerId,
                customerName: customerName,
                sender: data.sender,
                recipients: data.recipients.map(
                    (x: { name: string; email: string }) => ({
                        value: x.email,
                        label: `${x.name} (${x.email})`,
                    })
                ),
                bccs: data.bccs.map((x: { name: string; email: string }) => ({
                    value: x.email,
                    label: `${x.name} (${x.email})`,
                })),
                subject: this.state.data.jobName,
                message: "See Requested Quote Attached",
            });
        }
    }

    private async sendEmail(data: any, customerId?: number) {
        this.setState({ emailStatus: undefined });

        let response: Response;
        if (customerId !== undefined) {
            response = await apifetch(
                `quotes/email/${this.props.match.params.id}/customer/${customerId}`,
                {
                    headers: new Headers({
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    }),
                    method: "POST",
                    body: JSON.stringify(data),
                },
                true
            );
        } else {
            response = await apifetch(
                `quotes/email/${this.props.match.params.id}`,
                {
                    headers: new Headers({
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    }),
                    method: "POST",
                    body: JSON.stringify(data),
                },
                true
            );
        }

        if (response.ok) {
            this.setState({
                emailStatus: {
                    type: "success",
                    message: "Email sent successfully. Check your SMTP inbox or local pickup directory to validate the message.",
                },
            });
        } else {
            const message = await extractErrorMessage(response);
            this.setState({
                emailStatus: {
                    type: "error",
                    message,
                },
            });
        }
    }

    private async handleViewGrossMargin(
        event: React.MouseEvent<HTMLAnchorElement>
    ) {
        event.preventDefault();

        const response = await apifetch(
            "reports/gross-margin.xlsx",
            {
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
                method: "POST",
                body: JSON.stringify(this.state.data),
            },
            true
        );

        downloadResponse(response);
    }

    private handleStartEditQuoteStatus(
        event: React.MouseEvent<HTMLAnchorElement>
    ) {
        event.preventDefault();

        this.setState({
            isEditingQuoteStatus: true,
        });
    }

    private async handleQuoteStatusChanged(
        event: React.ChangeEvent<HTMLSelectElement>
    ) {
        let quoteStatusId = parseInt(event.currentTarget.value, 10);

        this.state.data.quoteStatusId = quoteStatusId;
        this.state.data.quoteStatusName =
            event.currentTarget.options[event.currentTarget.selectedIndex].text;
        this.setState({
            isEditingQuoteStatus: false,
            data: this.state.data,
        });

        let response = await apifetch(
            "quotes/" + this.props.match.params.id + "/setstatus",
            {
                method: "POST",
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify({ status: event.currentTarget.value }),
            },
            true
        );
    }

    private async scrollToSalesOrderHistory(
        event: React.MouseEvent<HTMLButtonElement> | any = undefined
    ) {

        !this.state.data.isMaster &&
            this.state.data.canCreateSalesOrder &&
            this.setState({ historySection: 1 });

        this.bottomTabs.current.scrollIntoView({ behavior: "smooth" });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/View.tsx